// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @20.06.2017 14:23:48
import { AtomicResult_abstract } from './../../abstract/SagaBase/Defines/AtomicResult_abstract';
export class AtomicResult extends AtomicResult_abstract {}
